export const initialState = {
    filter: {
        firstName: null,
        sername: null,
        charge: null,
        chargeId: null,
        regional: null,
        regionalId: null
    },
    isFilter: false,
};

const filterPermissionsReducer = (state= initialState, action) =>{
    switch (action.type) {
        case "SET_PERMISSIONS_FILTER":
            return {
                ...state,
                filter: action.filter,
                isFilter: action.isFilter,
            }
    
        default:
            return state;
    }
}
export default filterPermissionsReducer;